import { Link } from 'react-router-dom';

/**
 * 全站页脚（合规基建，2026-10-20）：
 * - 双协议入口（隐私政策 / 用户协议），公开页与登录后布局共用；
 * - ICP 备案号占位——备案办理完成后替换为真实号码并链接工信部备案查询页。
 *   占位文案如实告知「备案办理中」，不假装已备案（法商叙事的第一课是别自己造假）。
 */
export function SiteFooter() {
  return (
    <footer className="site-footer">
      <div className="site-footer-inner">
        <span>© 2026 CrossMatch · 松江七校跨校组队引擎</span>
        <nav className="site-footer-links" aria-label="页脚导航">
          <Link to="/privacy">隐私政策</Link>
          <Link to="/terms">用户协议</Link>
        </nav>
        <span className="site-footer-icp">ICP 备案号：待公示（备案办理中）</span>
      </div>
    </footer>
  );
}
